<script setup lang="ts">
useDocueAgentProvider()
</script>

<template>
  <main class="flex size-full min-h-0 flex-col overflow-hidden">
    <div class="min-h-0 flex-1">
      <slot />
    </div>
    <AppDocueAgentFooter />
  </main>
</template>
